var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":"","color":"transparent","height":"50"}},[_c('h3',[_c('v-btn',{staticClass:"link-button",attrs:{"flat":"","fab":"","small":"","color":"primary"},on:{"click":_vm.back}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35fb92b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appbar.vue
// module id = null
// module chunks = 